import React from "react";

export default function Grid(props) {
    return(
        <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            {props.children}
        </div>
    );
}